module.exports = __webpack_public_path__ + "img/notthesame.ccc9e42d.png";